import { useParams } from 'react-router-dom';

import Spinner from 'components/molecules/Spinner';
import JobDetailsForm from 'containers/Layout/forms/JobDetailForm';
import { useGetUserInfoQuery } from 'app-redux/apiSlice';

const JobDetailsView = () => {
  const { employeeId } = useParams();

  const { data: user, isLoading: userIsLoading } = useGetUserInfoQuery(
    employeeId || ''
  );

  if (userIsLoading) {
    return <Spinner fullPage text="User information loading..." />;
  }

  return <JobDetailsForm defaultValues={user} />;
};

export default JobDetailsView;
